// extracted by mini-css-extract-plugin
export var archives = "SiteFooter__archives-dr0iu";
export var archivesTitle = "SiteFooter__archivesTitle-3FfZR";
export var bar = "SiteFooter__bar--sPky";
export var button = "SiteFooter__button-oQGMo";
export var copyright = "SiteFooter__copyright-4iWJq";
export var icons = "SiteFooter__icons-2TnlE";
export var list = "SiteFooter__list--8w4N";
export var listItem = "SiteFooter__listItem-s4ILG";
export var listLink = "SiteFooter__listLink-0kme0";
export var message = "SiteFooter__message-t2j-L";
export var nav = "SiteFooter__nav-jLvxG";
export var navIcon = "SiteFooter__navIcon-8x9KM";
export var navItem = "SiteFooter__navItem-yOqPy";
export var navLink = "SiteFooter__navLink-7u3KY";
export var navText = "SiteFooter__navText-6JHm-";
export var row = "SiteFooter__row-JXRBB";
export var wrapper = "SiteFooter__wrapper-Krc-a";